import { AgoraRTCProvider, LocalUser, RemoteUser } from 'agora-rtc-react';
import { useMemo, useState } from 'react';
import { rouletteService } from '../../services/roulette.service';

import { useAgoraRoom } from './hooks/useAgoraRoom';
import AgoraRTC from 'agora-rtc-react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
// import { RouletteMatchScreen } from '../../components/MatchScreen';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

import { useSelector } from 'react-redux';
import { RouletteOpenChat } from './RouletteOpenChat';
import { checkLimitError } from '../../components/limits/utils/checkLimitError';
import { LimitModal } from '../../components/limits/LimitModal';
import { apiLimits } from '../../api/apiLimits.api';
import { NotificationBySubscription } from '../subscription/NotificationBySubscription';

const DELAY_TO_END_SESSION = 25_000;

const InteractiveVideoCalling = () => {
  const [clientKey, setClientKey] = useState(0);

  const client = useMemo(() => {
    return AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
  }, [clientKey]);

  const handleResetClient = async () => {
    try {
      await client.leave();
    } catch (e) {}

    setClientKey((prev) => prev + 1);
  };

  return (
    <AgoraRTCProvider key={clientKey} client={client}>
      <Roulette onReset={handleResetClient} />
    </AgoraRTCProvider>
  );
};

function Roulette({ onReset }) {
  const axiosPrivate = useAxiosPrivate();
  const userId = useSelector((state) => state.auth.userId);

  const [count, setCount] = useState(0);

  const [session, setSession] = useState({});
  const [users, setUsers] = useState([]);

  const [searching, setSearching] = useState(false);
  const [isMatched, setIsMatched] = useState(false);
  const [timerToEnd, setTimerToEnd] = useState(0);
  const [limitsKey, setLimitsKey] = useState(null);

  const isSessionActive = session.status === 'active';
  const recipientId = users.find((u) => u._id.toString() !== userId)?._id.toString() ?? null;
  const userPhotos = users.length ? users.map((u) => u.photo) : [];

  const myPositionUser =
    session?.userA?.toString() === userId ? 'A' : session?.userB?.toString() === userId ? 'B' : null;

  const isLikeHem = myPositionUser === 'A' ? session?.isMatchA : myPositionUser === 'B' ? session?.isMatchB : null;

  const [agoraToken, setAgoraToken] = useState('');
  const [agoraChannel, setAgoraChannel] = useState('');

  const { localCameraTrack, localMicrophoneTrack, remoteUser } = useAgoraRoom({
    agoraToken,
    agoraChannel,
    micOn: true,
    cameraOn: true,
    connect: isSessionActive
  });

  console.log('localCameraTrack, localMicrophoneTrack', localCameraTrack, localMicrophoneTrack);

  useEffect(() => {
    apiLimits.fetchMyLimits(axiosPrivate).then((res) => {
      const limit = res.limits['video']['partners']?.remaining;

      if (limit <= 0) {
        setLimitsKey('partners');
      }
    });

    rouletteService.connect();

    const unsubMatch = rouletteService.onMatched((data) => {
      const { agora, session, users } = data;

      setAgoraChannel(agora.channel);
      setAgoraToken(agora.token);
      setSession(session);
      setUsers(users);
      setSearching(false);
    });

    const onsubIsLikeMatched = rouletteService.onIsLikeMatched((data) => {
      setIsMatched(data.isMatch);
      setSession(data.session);
    });

    const onsubEndSession = rouletteService.onEndSession((data) => {
      setSession(data.session);
      resetSession();
    });

    const onsubError = rouletteService.onErrors((data) => {
      const message = data?.message;

      const limitKey = checkLimitError(message);

      if (limitKey) {
        setLimitsKey(limitKey);
      } else {
        toast.error(message);
      }
    });

    return () => {
      unsubMatch();
      onsubIsLikeMatched();
      onsubEndSession();
      onsubError();
      rouletteService.skipSession();
    };
  }, []);

  useEffect(() => {
    if (!isSessionActive) return;

    const timer = setTimeout(() => {
      handleSkipSession();
    }, DELAY_TO_END_SESSION);

    const interval = setInterval(() => {
      setTimerToEnd((prev) => {
        if (prev === DELAY_TO_END_SESSION) {
          clearInterval(interval);
          return prev;
        }
        return (prev += 1000);
      });
    }, 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [isSessionActive]);

  const handleStartSearch = () => {
    if (!localCameraTrack) {
      return toast.error('Камера не подключена. Пожалуйста, разрешите доступ к камере и попробуйте снова.');
    }

    rouletteService.startSearch();
    setSearching(true);
    setIsMatched(false);
    setSession({});
  };

  const handleLikeToUser = () => {
    rouletteService.likeToUser();
  };

  const handleSkipSession = async () => {
    rouletteService.skipSession();
    await resetSession();
  };

  const resetSession = async () => {
    setIsMatched(false);
    setTimerToEnd(0);
    setAgoraToken('');
    setAgoraChannel('');
    setSession({});
    setUsers([]);

    await onReset();
    setCount((prev) => (prev += 1));
  };

  const showIsSearching = searching;
  const showMiniFrontCamera = showIsSearching || isSessionActive;

  return (
    <>
      <div className="relative flex flex-col h-[calc(100%-178px)] overflow-hidden mx-4 rounded-2xl">
        <NotificationBySubscription count={count} resetCount={() => setCount(0)} minCount={20} />
        {isSessionActive && (
          <div className="absolute z-20 top-4 left-2 right-2 h-1 rounded-full bg-white/50">
            <div
              className="h-full bg-white rounded-full transition-all"
              style={{ width: `${(timerToEnd * 100) / DELAY_TO_END_SESSION}%` }}
            />
          </div>
        )}
        {remoteUser && isSessionActive && (
          <RemoteUser className="rounded-2xl" style={{ width: '100%', height: '100%' }} user={remoteUser} />
        )}
        {showIsSearching && (
          <div className="flex flex-col gap-5 items-center justify-center w-full h-full">
            <img
              src="/icons/video_chat_wait.svg"
              alt="video_chat_wait"
              className="w-[48px] h-[48px] animate-spin transition duration-1000"
            />
            <p className="text-center font-medium text-[20px] text-white">Ищем собеседника. Пожалуйста подождите...</p>
          </div>
        )}
        <div
          className={`transition-all duration-500 ease-in-out absolute z-10  overflow-hidden rounded-2xl ${showMiniFrontCamera ? 'w-1/3 h-1/3 top-8 right-2' : 'w-full h-full'}`}
        >
          <LocalUser
            audioTrack={localMicrophoneTrack}
            cameraOn={true}
            micOn={true}
            playAudio={false}
            videoTrack={localCameraTrack}
            style={{ width: '100%', height: '100%' }}
          />
        </div>

        <div className="absolute z-10 bottom-4 left-4 right-4">
          {(isSessionActive || showIsSearching) && (
            <div className="flex items-center justify-center gap-4">
              <button
                className="size-[64px] disabled:opacity-50 group"
                disabled={showIsSearching}
                onClick={handleSkipSession}
              >
                <svg width="64" height="64" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect
                    x="0.46875"
                    y="0.96875"
                    width="39.0625"
                    height="39.0625"
                    rx="19.5312"
                    fill="black"
                    fillOpacity="0.3"
                  />
                  <rect
                    x="0.46875"
                    y="0.96875"
                    width="39.0625"
                    height="39.0625"
                    rx="19.5312"
                    stroke="white"
                    strokeWidth="0.9375"
                    className="group-hover:stroke-[#CE5D49]"
                  />
                  <g clip-path="url(#clip0_234_3743)">
                    <path
                      className="group-hover:fill-[#CE5D49]"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.2742 14.5115C14.9255 14.1628 14.3602 14.1628 14.0115 14.5115C13.6628 14.8602 13.6628 15.4255 14.0115 15.7742L18.7373 20.5L14.0115 25.2258C13.6628 25.5745 13.6628 26.1398 14.0115 26.4885C14.3602 26.8371 14.9255 26.8371 15.2742 26.4885L20 21.7627L24.7258 26.4885C25.0745 26.8371 25.6398 26.8371 25.9885 26.4885C26.3371 26.1398 26.3371 25.5745 25.9885 25.2258L21.2627 20.5L25.9885 15.7742C26.3371 15.4255 26.3371 14.8602 25.9885 14.5115C25.6398 14.1628 25.0745 14.1628 24.7258 14.5115L20 19.2373L15.2742 14.5115Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_234_3743">
                      <rect width="12.5" height="12.5" fill="white" transform="translate(13.75 14.25)" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <RouletteOpenChat recipientId={recipientId} disabled={showIsSearching} />
              <button
                className="size-[64px] disabled:opacity-50 group"
                disabled={showIsSearching}
                onClick={handleLikeToUser}
              >
                <svg width="64" height="64" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect
                    x="0.46875"
                    y="0.96875"
                    width="39.0625"
                    height="39.0625"
                    rx="19.5312"
                    fill="black"
                    fillOpacity="0.3"
                  />
                  <rect
                    x="0.46875"
                    y="0.96875"
                    width="39.0625"
                    height="39.0625"
                    rx="19.5312"
                    className="group-hover:stroke-[#A1F69E]"
                    stroke={isLikeHem ? '#A1F69E' : 'white'}
                    strokeWidth="0.9375"
                  />
                  <g clipPath="url(#clip0_234_3734)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16.8112 14.1623C17.8617 14.2384 18.9564 14.7506 20.0043 15.787C21.052 14.7509 22.1457 14.2397 23.1953 14.1653C24.3799 14.0813 25.4271 14.56 26.1848 15.3154C27.6744 16.8006 28.1422 19.4879 26.2937 21.3364C26.2875 21.3426 26.2811 21.3487 26.2746 21.3546L20.364 26.7085C20.1598 26.8933 19.8488 26.8933 19.6447 26.7085L13.7341 21.3546C13.7275 21.3487 13.7211 21.3426 13.7149 21.3364C11.8568 19.4783 12.3221 16.7906 13.8166 15.3066C14.5762 14.5524 15.6255 14.0764 16.8112 14.1623Z"
                      fill={isLikeHem ? '#A1F69E' : 'white'}
                      className="group-hover:fill-[#A1F69E]"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_234_3734">
                      <rect width="15" height="15" fill="white" transform="translate(12.5 12.9995)" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          )}
          {!isSessionActive && !showIsSearching && (
            <button onClick={handleStartSearch} className="w-full rounded-full bg-[#A1F69E] p-[18.5px]">
              Найти собеседника
            </button>
          )}
        </div>

        {/* {isMatched && (
          <RouletteMatchScreen
            userAPhotoUrl={userPhotos[0]}
            userBPhotoUrl={userPhotos[1]}
            recipientId={recipientId}
            close={() => setIsMatched(false)}
          />
        )} */}
        {limitsKey && (
          <LimitModal
            domain="video"
            limitsKey={limitsKey}
            fullScreen={limitsKey === 'partners'}
            setLimitsKey={setLimitsKey}
          />
        )}
      </div>
    </>
  );
}

export default InteractiveVideoCalling;
